// extracted by mini-css-extract-plugin
export default {"buttonGroup":"SwitchControl_buttonGroup__YGawp","button":"SwitchControl_button__88Iu0","activeButton":"SwitchControl_activeButton__xqwUP"};